module.exports = __webpack_public_path__ + "img/专精特新.e9e562a4.jpg";